import React from 'react'
import { Card as AntCard, CardProps as AntCardProps } from 'antd'

export interface AppCardProps extends AntCardProps {
  /**
   * 是否无边框（向后兼容属性）
   * 如果设置了variant属性，则variant优先
   * @default false
   */
  borderless?: boolean
}

/**
 * 应用卡片组件
 *
 * 包装Ant Design的Card组件，提供更好的类型安全和向后兼容性。
 * 自动处理废弃的bordered属性，使用variant属性替代。
 *
 * @example
 * // 有边框卡片（默认）
 * <AppCard title="卡片标题">内容</AppCard>
 *
 * // 无边框卡片
 * <AppCard borderless title="无边框卡片">内容</AppCard>
 *
 * // 使用variant属性直接控制
 * <AppCard variant="filled" title="填充卡片">内容</AppCard>
 *
 * // 所有Ant Card属性都支持
 * <AppCard
 *   title="自定义卡片"
 *   extra={<Button>操作</Button>}
 *   style={{ borderRadius: '12px' }}
 * >
 *   内容
 * </AppCard>
 */
const AppCard: React.FC<AppCardProps> = ({
  borderless = false,
  variant,
  ...props
}) => {
  // 确定最终的variant值
  // 1. 如果显式设置了variant，使用它
  // 2. 否则，如果borderless为true，使用'borderless'
  // 3. 否则，使用默认的'outlined'
  const finalVariant = variant || (borderless ? 'borderless' : 'outlined')

  return <AntCard variant={finalVariant} {...props} />
}

export default AppCard